module.exports = __webpack_public_path__ + "img/room.24e51cd9.svg";